import { Link } from 'react-router';
import { UserProfession } from '~/enums/UserProfession';
import { Colors } from '~/themes/colors';
import { Box, Column, Row, Text } from '~/commonComponents';
import { IProfessionalCardUser } from '../../interfaces';
import { ProfessionalRating } from '../ProfessionalRating';

interface IProfessionalCardDetailsProps {
  user: IProfessionalCardUser;
}

export const ProfessionalCardDetails = ({ user }: IProfessionalCardDetailsProps) => {
  const { id, isAvailable, fullname, activityLevel, professions, rating } = user;
  const unavailableColorText = isAvailable ? Colors.neutral_500 : Colors.neutral_300;

  return (
    <Column justifyContent="center" marginLeft={24} gap={4}>
      <Row alignItems="center" gap={8}>
        <Text
          bold
          fontSize={22}
          maxWidth={300}
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
          opacity={isAvailable ? 1 : 0.5}
        >
          {fullname}
        </Text>

        <Row alignItems="center" justifyContent="center" gap={7}>
          <ProfessionalRating rating={rating} isAvailable={isAvailable} />
          <Box height={20} width={2} backgroundColor={Colors.neutral_600} />
          {isAvailable ? (
            <Link to={`/dashboard/professional/${id}`} style={{ textDecoration: 'none' }}>
              <Text bold color={Colors.secondary_500} fontSize={20}>
                Profile
              </Text>
            </Link>
          ) : (
            <Text bold color={Colors.secondary_200} fontSize={20}>
              Profile
            </Text>
          )}
        </Row>
      </Row>
      <Row alignItems="center" gap={12}>
        <Text style={{ color: unavailableColorText }}>
          {UserProfession.getName(professions?.[0] || '')}
        </Text>
        <Text bold style={{ color: unavailableColorText }}>
          • Activity Level:{' '}
          <Text style={{ color: unavailableColorText, textTransform: 'capitalize' }}>
            {activityLevel}
          </Text>
        </Text>
        {!isAvailable && (
          <Text style={{ color: unavailableColorText }}>• Currently Unavailable</Text>
        )}
      </Row>
    </Column>
  );
};
